import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-inward-requests',
  templateUrl: './inward-requests.component.html',
  styleUrls: ['./inward-requests.component.less']
})
export class InwardRequestsComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
